import React from 'react'

const IconHex = ({ style = {}, ...props }) => {
  return (
    <svg
      width="28"
      height="26"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}>
      <path
        d="M25.2 11a2 2 0 1 0 0-4h-3.58l.84-4.64a2.003 2.003 0 1 0-3.94-.72l-1 5.36h-4.9l.84-4.64a2.003 2.003 0 1 0-3.94-.72L8.52 7H4.2a2 2 0 1 0 0 4h3.63l-.73 4H2.8a2 2 0 1 0 0 4h3.58l-.84 4.64a2.003 2.003 0 1 0 3.94.72l1-5.36h4.93l-.84 4.64a2.003 2.003 0 1 0 3.94.72l1-5.36h4.29a2 2 0 1 0 0-4h-3.63l.73-4h4.3zm-9.1 4h-4.93l.73-4h4.93l-.73 4z"
        fill="#77CA34"
      />
    </svg>
  )
}

export default IconHex
